<template>
  <v-card flat>
    <v-expansion-panels
      :class="single ? '' : 'pa-2'"
      :flat="single"
      :mandatory="single"
      focusable
    >
      <v-expansion-panel
        v-for="(salon, index) in gallery"
        :key="index"
        :class="{ single: single }"
        class="mt-2 rounded-lg"
      >
        <v-expansion-panel-header
          v-if="editName"
          :hide-actions="single"
          :style="
            single
              ? 'background-color: transparent !important; color: inherit !important;'
              : ''
          "
        >
          <div class="rowinfo">
            <div class="contentinfo" style="max-width: 100% !important">
              <div>
                <div v-if="index !== editGalleryName" class="d-inline-block">
                  {{ salon.name }}
                </div>
                <div
                  class="rowinfo justify-end"
                  v-if="index === editGalleryName"
                >
                  <v-text-field
                    v-model="salon.name"
                    class="my-2 d-inline-block"
                    dense
                    hide-details
                    label="نام گالری"
                    outlined
                    @click.stop
                    @keydown.enter="editGalleryName = -1"
                  >
                    <template v-slot:append>
                      <v-btn
                        class="mt-n1 ml-n1"
                        icon
                        small
                        @click.stop="editGalleryName = -1"
                      >
                        <v-icon style="color: currentColor !important"
                          >mdi-check</v-icon
                        >
                      </v-btn>
                    </template>
                  </v-text-field>
                </div>

                <v-tooltip v-else left>
                  <template v-slot:activator="{ on, attr }">
                    <v-btn
                      icon
                      small
                      v-bind="attr"
                      v-on="on"
                      @click.stop="editGalleryName = index"
                    >
                      <v-icon small style="color: currentColor !important"
                        >mdi-pencil</v-icon
                      >
                    </v-btn>
                    <v-btn
                      v-if="!single"
                      class="float-left"
                      icon
                      max-width="36"
                      @click="gallery.splice(index, 1)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <span>تغییر نام گالری</span>
                </v-tooltip>
                <v-spacer />
              </div>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mt-4 mx-0 px-0">
          <div class="d-flex align-start mx-0 px-0">
            <div class="rowinfo" style="width: 100% !important">
              <v-btn
                :disabled="disabled"
                class="contentinfo btn-download lounded-lg"
                style="flex: 1 1 auto !important"
                outlined
                @click="editGallery(index)"
              >
                <v-icon>mdi-image</v-icon>
                انتخاب عکس
              </v-btn>
            </div>
          </div>

          <v-row v-if="salon.images && salon.images.length > 0" no-gutters>
            <v-col class="pa-2" cols="12">
              <v-switch
                v-model="showImages"
                dense
                hide-details
                label="نمایش تصویر"
              />
            </v-col>

            <v-col
              v-for="(image, index) in salon.images"
              :key="index"
              class="align-center pa-2 position-relative"
              cols="12"
            >
              <div class="rowinfo" style="width: 100% !important">
                <div class="contentinfo" style="max-width: 100% !important">
                  <div class="border rounded" style="height: 100%">
                    <v-btn
                      class="float-end zindex-5 p-0 ms-auto my-auto"
                      icon
                      small
                      @click="deleteSelectedImage(salon, image)"
                    >
                      <v-icon style="color: #999 !important">mdi-delete</v-icon>
                    </v-btn>

                    <v-card
                      :ripple="false"
                      class="px-2 text-center d-flex align-center justify-space-between"
                      flat
                      height="100%"
                      @click="selectImage(image)"
                    >
                      <v-btn
                        :disabled="salon.images.indexOf(image) === 0"
                        icon
                        @click.stop="moveUp(salon, image)"
                      >
                        <v-icon v-if="salon.images.indexOf(image) !== 0"
                          >mdi-chevron-up</v-icon
                        >
                      </v-btn>

                      <v-img
                        v-if="showImages"
                        :src="image.url"
                        class="btn col-8 rounded img-fluid border-5 border mx-auto my-auto"
                        style="box-shadow: #ccb4bb 0 0 3px"
                      />

                      <div
                        v-else
                        class="cursor-pointer"
                        style="max-width: 100%"
                        v-text="image.name"
                      />

                      <v-btn
                        :disabled="
                          salon.images.indexOf(image) ===
                          salon.images.length - 1
                        "
                        icon
                        @click.stop="moveDown(salon, image)"
                      >
                        <v-icon
                          v-if="
                            salon.images.indexOf(image) !==
                            salon.images.length - 1
                          "
                          >mdi-chevron-down</v-icon
                        >
                      </v-btn>
                    </v-card>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <custom-popup
      id="gallery"
      v-model="dialog"
      :cons="{ title: 'انتخاب عکس' }"
      eager
      max-width="960"
      reloadable
      @reload="getImages()"
    >
      <v-card
        :loading="loading || defLoading"
        flat
        min-height="300"
        style="overscroll-behavior: contain"
      >
        <custom-tabs
          v-model="tabs"
          :tabItems="tabItems"
          :windowItems="tabItems"
          :tabProps="{ color: 'primary' }"
          :tabsItemsAttrs="{ color: 'primary' }"
          show-arrows
          grow
        >
          <template v-slot:tab="{ tab }">
            <v-icon right>{{ tab.icon }}</v-icon>
            <span class="font-weight-bold">{{ tab.text }}</span>
          </template>

          <template v-slot:item="{ item }">
            <div v-if="item.id === 0">
              <together-ai-image @saved="gotoSaved" />
            </div>
            <div
              v-else-if="item.id === 1"
              style="
                max-height: calc(100vh - 233px);
                overflow-y: auto;
                position: relative;
              "
            >
              <v-row
                class="px-2 white"
                no-gutters
                style="position: sticky; top: 0; z-index: 1"
              >
                <v-col class="pa-2" cols="12" md="2">
                  <div class="rowinfo">
                    <v-select
                      v-model="per_page"
                      :items="[10, 25, 50, 100]"
                      :menu-props="{ offsetY: true }"
                      class="rounded-lg contentinfo"
                      dense
                      hide-details
                      label="تعداد"
                      outlined
                      @change="getDefaultImages(true)"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="5">
                  <div class="rowinfo">
                    <v-autocomplete
                      v-model="catSearch"
                      :items="defImg.categories"
                      class="rounded-lg contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      hide-details
                      label="انتخاب دسته‌بندی"
                      outlined
                      @change="getDefaultImages(true)"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="5">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="search"
                      class="rounded-lg contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      hint="پس از تایپ، دکمه اینتر را کلیک کنید."
                      label="جستجو"
                      outlined
                      persistent-hint
                      @click:clear="
                        () => {
                          search = '';
                          getDefaultImages(true);
                        }
                      "
                      @keydown.enter="getDefaultImages(true)"
                    />
                  </div>
                </v-col>
              </v-row>

              <v-row
                v-if="!!defImg.items && showDefResult"
                class="pa-3 custom-scrollbar"
                no-gutters
              >
                <v-col
                  v-if="
                    (!defImg.items.data || !defImg.items.data.length) &&
                    !defLoading
                  "
                  class="pa-2"
                  cols="12"
                >
                  <v-card-title class="text-center justify-center">
                    تصویری موجود نیست
                  </v-card-title>
                </v-col>

                <template v-else>
                  <v-col
                    v-for="image in defImg.items.data"
                    :key="image.id"
                    :data-img="image.id"
                    class="pa-1"
                    cols="12"
                    md="4"
                    @click="select(image)"
                  >
                    <v-img
                      :key="image.id"
                      :aspect-ratio="16 / 9"
                      :class="
                        computedEditingGallery.images.findIndex(
                          (item) => item.id === image.id,
                        ) > -1
                          ? 'border border-2 border-success'
                          : ''
                      "
                      :lazy-src="image.full_path"
                      :src="image.full_path"
                      class="rounded"
                    >
                      <template
                        v-if="
                          computedEditingGallery.images.findIndex(
                            (item) => item.id === image.id,
                          ) > -1
                        "
                        v-slot:default
                      >
                        <v-checkbox
                          :input-value="true"
                          class="ma-2"
                          color="success"
                          dense
                          hide-details
                          readonly
                        />
                      </template>
                    </v-img>
                  </v-col>

                  <v-col cols="12">
                    <v-card
                      v-if="
                        !defLoading &&
                        !defIsLastPage &&
                        tabs === 1 &&
                        !getDefError
                      "
                      v-intersect="onDefaultIntersect"
                      flat
                      height="200"
                    >
                      <v-progress-circular
                        color="primary"
                        indeterminate
                        size="35"
                        width="5"
                      />
                    </v-card>
                  </v-col>
                </template>
              </v-row>

              <v-card
                v-else-if="!defLoading"
                class="d-flex flex-column align-center justify-center mx-auto"
                flat
                max-width="400"
              >
                <v-img max-width="120" src="/media/img/has_no_image.jpg" />
                <v-card-text class="text-center">
                  برای استفاده از تصاویر آماده، نام دسته یا محصول مورد نظر خود
                  را از فیلدهای بالا جستجو کنید.
                </v-card-text>
              </v-card>
            </div>
            <div v-else-if="item.id === 2">
              <v-card class="pa-2" flat>
                <slot name="default">
                  <v-card-text>
                    <v-file-input
                      ref="fileInput"
                      v-model="filesModel"
                      :loading="upLoading"
                      accept="image/png,image/jpeg"
                      class="d-none"
                      clearable
                      dense
                      hint="حداکثر حجم هر فایل مورد نظر می‌تواند 2 مگابایت باشد."
                      multiple
                      outlined
                      truncate-length="7"
                      @change="handleFileUpload"
                      @click:clear="filesModel = null"
                    />
                  </v-card-text>

                  <v-card
                    id="uploader"
                    ref="uploader"
                    class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
                    height="200"
                    max-width="700"
                    outlined
                    @click="dragEvent"
                    @dragleave="dragEvent"
                    @dragover="dragEvent"
                    @drop="dragEvent"
                  >
                    <v-icon size="68" style="opacity: 0.4"
                      >mdi-cloud-upload-outline</v-icon
                    >
                    <v-card-title class="justify-center"
                      >آپلود فایل</v-card-title
                    >
                    <v-card-text class="text-center pt-0">
                      برای آپلود بکشید و رها کنید یا
                      <v-btn class="mx-1" color="primary" min-width="75" small>
                        اینجا
                      </v-btn>
                      کلیک کنید
                    </v-card-text>
                  </v-card>

                  <v-card
                    class="d-flex flex-wrap mx-auto pa-2"
                    flat
                    max-width="700"
                  >
                    <div
                      v-for="(item, i) in filesPreview"
                      :key="i"
                      class="pa-1 text-center d-flex justify-space-between flex-column"
                      style="max-width: 100px; width: 100px"
                    >
                      <div>
                        <v-img
                          :src="item.url"
                          aspect-ratio="1"
                          class="rounded-lg"
                          width="100%"
                        >
                          <div
                            v-if="!upLoading && (!item.status || !item.color)"
                            class="text-left fill-height"
                          >
                            <v-btn icon @click="removeFileFromUpload(i)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </div>

                          <div
                            v-else-if="upLoading && item.status === 'loading'"
                            class="d-flex justify-center align-center fill-height"
                            style="background: rgba(0, 0, 0, 0.5)"
                          >
                            <v-progress-circular
                              color="white"
                              indeterminate
                              size="40"
                              width="5"
                            />
                          </div>

                          <v-card
                            v-else-if="!!item.color"
                            class="d-flex align-center justify-center"
                            color="rgba(0, 0, 0, .5)"
                            flat
                            height="100%"
                            width="100%"
                          >
                            <v-avatar :color="item.color">
                              <v-icon
                                >mdi-{{
                                  !!item.status ? "check" : "close"
                                }}</v-icon
                              >
                            </v-avatar>
                          </v-card>
                        </v-img>
                      </div>
                      <span class="mt-1">{{ item.name }}</span>
                    </div>
                  </v-card>
                </slot>

                <v-card-text>
                  <slot
                    name="extension"
                    v-bind="{ cats: computedCats, def: defaultCatName }"
                  >
                    <cat-to-upload
                      v-if="showCatUpload"
                      v-model="categoryName"
                      :items="computedCats"
                      :loading="upLoading"
                      @action="uploadFiles"
                      @clear="clearUpload"
                    />
                  </slot>
                </v-card-text>
              </v-card>
            </div>
            <div v-else-if="item.id === 3">
              <v-tabs v-model="innerTabs" color="deep-purple accent-4" light>
                <v-tab v-text="'همه'" />
                <v-tab v-for="(category, j) in img.categories" :key="j">{{
                  category
                }}</v-tab>
              </v-tabs>

              <v-divider class="my-0" />

              <v-tabs-items v-model="innerTabs">
                <v-tab-item>
                  <v-row
                    class="pa-3 custom-scrollbar"
                    no-gutters
                    style="max-height: calc(90vh - 300px); overflow-y: auto"
                  >
                    <v-col
                      v-for="(image, j1) in img.items.data"
                      :key="image.id"
                      :data-img="image.id"
                      class="pa-1"
                      cols="12"
                      md="4"
                      @click="select(image)"
                    >
                      <v-img
                        :key="image.id"
                        :aspect-ratio="16 / 9"
                        :class="
                          computedEditingGallery.images.findIndex(
                            (item) => item.id === image.id,
                          ) > -1
                            ? 'border border-2 border-success'
                            : ''
                        "
                        :lazy-src="image.full_path"
                        :src="image.full_path"
                        class="rounded"
                      >
                        <template
                          v-if="
                            computedEditingGallery.images.findIndex(
                              (item) => item.id === image.id,
                            ) > -1
                          "
                          v-slot:default
                        >
                          <v-checkbox
                            :input-value="true"
                            class="ma-2"
                            color="success"
                            dense
                            hide-details
                            readonly
                          />
                        </template>
                      </v-img>
                    </v-col>

                    <v-col cols="12">
                      <v-card
                        v-if="
                          !loading && !isLastPage && tabs === 3 && !getError
                        "
                        v-intersect="onIntersect"
                      >
                        <v-progress-circular
                          color="primary"
                          indeterminate
                          size="35"
                          width="5"
                        />
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>

                <v-tab-item v-for="(item, j) in img.categories" :key="j">
                  <v-row
                    v-if="!!img.items && !!img.items.data"
                    class="pa-3 custom-scrollbar"
                    no-gutters
                    style="max-height: calc(90vh - 300px); overflow-y: auto"
                  >
                    <v-col
                      v-for="image in img.items.data.filter(
                        (itemImg) => itemImg.category === item,
                      )"
                      :key="image.id"
                      :data-img="image.id"
                      class="pa-1"
                      cols="12"
                      md="4"
                      @click="select(image)"
                    >
                      <v-img
                        :key="image.id"
                        :aspect-ratio="16 / 9"
                        :class="
                          computedEditingGallery.images.findIndex(
                            (item) => item.id === image.id,
                          ) > -1
                            ? 'border border-2 border-success'
                            : ''
                        "
                        :lazy-src="image.full_path"
                        :src="image.full_path"
                        class="rounded"
                      >
                        <template
                          v-if="
                            computedEditingGallery.images.findIndex(
                              (item) => item.id === image.id,
                            ) > -1
                          "
                          v-slot:default
                        >
                          <v-checkbox
                            :input-value="true"
                            class="ma-2"
                            color="success"
                            dense
                            hide-details
                            readonly
                          />
                        </template>
                      </v-img>

                      <!--                            <v-img :key="image.id" :aspect-ratio="16/9" :lazy-src="image.full_path"-->
                      <!--                                   :src="image.full_path" class="rounded"/>-->
                    </v-col>

                    <v-col cols="12">
                      <v-card
                        v-if="
                          !loading && !isLastPage && tabs === 3 && !getError
                        "
                        v-intersect="onIntersect"
                      >
                        <v-progress-circular
                          color="primary"
                          indeterminate
                          size="35"
                          width="5"
                        />
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>

              <v-card
                v-if="
                  !loading &&
                  (!img.categories ||
                    !img.categories.length ||
                    !img.items.data ||
                    !img.items.data.length)
                "
                flat
                style="max-height: calc(90vh - 250px); overflow-y: auto"
                width="100%"
              >
                <v-card-title
                  class="text-center justify-center"
                  v-text="'تصویری پیدا نشد!'"
                />
                <v-card-subtitle
                  class="text-center"
                  v-text="
                    'برای افزودن فایل از فیلد بازگذاری تصاویر یا آپلود سنتر استفاده نمایید'
                  "
                />
              </v-card>
            </div>
            <div v-else-if="item.id === 4">
              <v-card class="pa-2 pt-0">
                <v-card-title>افزودن تصویر</v-card-title>
                <v-card-subtitle>
                  برای استفاده از تصویر با لینک خارجی، لطفا فیلدهای زیر را پر
                  نمایید
                </v-card-subtitle>

                <v-row justify="center" no-gutters>
                  <!--                        <v-col class="pa-2" cols="12" lg="5" md="6">-->
                  <!--                          <v-text-field v-model="manualImage.title" class="my-2" dense hide-details label="عنوان"-->
                  <!--                                        outlined/>-->
                  <!--                        </v-col>-->

                  <!--                        <v-col class="pa-2" cols="12" lg="5" md="6">-->
                  <!--                          <v-text-field v-model="manualImage.link" class="my-2" dense hide-details-->
                  <!--                                        label="لینک" outlined/>-->
                  <!--                        </v-col>-->

                  <v-col
                    v-for="(m, i) in manualImage"
                    :key="i"
                    class="pa-2"
                    cols="12"
                    lg="10"
                    md="11"
                  >
                    <div class="rowinfo">
                      <v-text-field
                        v-model="m.url"
                        :rules="[rules.link]"
                        class="my-2 contentinfo"
                        dense
                        hint=" آدرس (لینک) تصویر مورد نظر."
                        label="آدرس تصویر"
                        outlined
                        persistent-hint
                      >
                        <template v-if="!onePic" v-slot:append>
                          <v-btn
                            class="mt-n1 ml-n1 contentinfo"
                            icon
                            @click="pushManual"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>

                  <!--                        <v-col class="pa-2" cols="12" lg="5" md="6">-->
                  <!--                          <v-textarea v-model="manualImage.description" class="my-2" dense hide-details-->
                  <!--                                      label="توضیحات" maxLength="250" outlined rows="1"/>-->

                  <!--                        </v-col>-->

                  <v-col class="text-left px-2 pb-2" cols="12" lg="10">
                    <div class="rowinfo">
                      <v-btn
                        class="btn-sub ms-auto px-8 contentinfo"
                        color="green lighten-3"
                        @click="addImageManual(computedEditingGallery)"
                      >
                        افزودن
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </template>
        </custom-tabs>
      </v-card>
    </custom-popup>

    <custom-popup
      v-if="editImg"
      id="edit-gallery"
      v-model="editDialog"
      :cons="cons"
      max-width="500"
    >
      <v-card class="p-8">
        <div class="rowinfo">
          <v-text-field
            v-model="selectedImage.title"
            class="my-2 contnetinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="عنوان"
            outlined
          />
        </div>
        <div class="rowinfo">
          <v-text-field
            v-model="selectedImage.link"
            :rules="[rules.link]"
            class="my-2 contentinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="لینک"
            outlined
          />
        </div>
        <div class="rowinfo">
          <v-textarea
            v-model="selectedImage.description"
            class="my-2 contentinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="توضیحات"
            maxLength="250"
            outlined
            rows="5"
          />
        </div>
      </v-card>
    </custom-popup>

    <v-card-actions v-if="!single" class="px-2 pt-6">
      <div class="rowinfo" style="width: 100% !important">
        <v-btn
          color="success"
          outlined
          @click="addGallery"
          class="contentinfo"
          style="flex: 1 1 auto !important"
        >
          افزودن گالری جدید
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { rbAxios } from "@/main";
import CatToUpload from "./catToUpload";
import TogetherAiImage from "../AIGeneration/togetherAiImage.vue";

export default {
  name: "picSelector",

  components: { TogetherAiImage, CatToUpload },

  props: {
    bracket: String,
    data: {
      type: Object,
      require: true,
    },
    defaultCatName: String,
    disabled: Boolean,
    editImg: {
      type: Boolean,
      default: true,
    },
    editName: {
      type: Boolean,
      default: true,
    },
    field: String,
    onePic: Boolean,
    value: Array,
    single: Boolean,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "picselector",
      tabItems: [
        {
          id: 0,
          text: "خلق تصویر",
          icon: "mdi-image-auto-adjust",
          value: "generate-image",
        },
        {
          id: 1,
          text: "تصاویر آماده",
          icon: "mdi-broadcast",
          value: "ready-image",
        },
        {
          id: 2,
          text: "افزودن تصویر",
          icon: "mdi-cloud-upload-outline",
          value: "add-image",
        },
        {
          id: 3,
          text: "گالری تصاویر",
          icon: "mdi-image-area-close",
          value: "gallery-image",
        },
        { id: 4, text: "لینک", icon: "mdi-link-plus", value: "link-image" },
      ],
      cons: {
        title: "ویرایش تصویر",
        buttons: [{ type: "submit", handler: this.changeObj }],
      },
      upLoading: false,
      loading: false,
      defLoading: false,
      dialog: false,
      manualDialog: false,
      editDialog: false,
      editingGallery: null,
      tabs: 0,
      innerTabs: 0,
      filesModel: null,
      // filesToUpload: [],
      filesPreview: [],
      categoryName: "",
      // errors: '',
      getError: false,
      getDefError: false,
      img: {
        items: {},
        categories: [],
      },
      defImg: {
        items: {},
      },
      isIntersecting: false,
      defIsLastPage: false,
      isLastPage: false,
      defPage: 1,
      page: 1,
      catSearch: undefined,
      search: undefined,
      showDefResult: false,
      per_page: 10,
      cats: [],
      url: process.env.VUE_APP_ROBOT,
      manualImage: [
        {
          title: "",
          url: "",
          description: "",
          link: "",
        },
      ],
      // gallery: [{name: 'گالری عکس', images: []}],
      selectedImage: {},
      editGalleryName: -1,
      showImages: false,
      rules: {
        link: (v) => !v || this.isLink(v) || "لینک صحیح وارد نمایید.",
      },
    };
  },

  computed: {
    computedCats() {
      if (
        !!this.img.categories?.length &&
        !this.img.categories.includes(this.defaultCatName)
      ) {
        let arr = [];
        arr.push(this.defaultCatName);
        return [...arr, ...this.img.categories];
      }

      return this.img.categories;
    },
    showCatUpload() {
      return (
        !this.$slots.extension &&
        !!this.filesModel &&
        typeof this.filesModel === "object" &&
        !!this.filesModel.length
      );
    },
    gallery: {
      get() {
        return !!this.value?.length
          ? this.value
          : !!this.data?.gallery
          ? this.data.gallery
          : this.single && this.onePic && !!this.field
          ? [
              {
                name: "",
                images: [
                  {
                    name: this.field.split("/").pop().toString(),
                    title: "",
                    url: this.field,
                    description: "",
                    link: "",
                    id: "",
                  },
                ],
              },
            ]
          : [
              {
                name: "",
                images: [],
              },
            ];
      },
      set(val) {
        if (!!this.value) this.$emit("input", val);
        if (!!this.data) {
          this.data["gallery"] = val;
        }

        console.log("changed: ", val);
        this.$emit("change");
        this.$nextTick(() => {
          this.$root.$emit("fetchDragList");
        });
      },
    },
    computedEditingGallery: {
      get() {
        return this.gallery[this.editingGallery] || null;
      },
      set(val) {
        this.gallery[this.editingGallery] = val;
      },
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.getError = this.getDefError = false;
      }
    },
    tabs(val) {
      if (
        val === 1 &&
        (!this.defImg.items || !this.defImg.items.data) &&
        !this.defLoading
      ) {
        this.getDefaultImages();
      } else if (
        val === 3 &&
        (!this.img.items || !this.img.items.data) &&
        !this.loading
      ) {
        this.getImages();
      }
    },
    innerTabs(val) {
      this.page = 1;
      this.isLastPage = false;
      this.isIntersecting = false;
      this.img.items = [];

      this.$nextTick(() => {
        this.getImages();
      });
    },
    showCatUpload(val) {
      if (val && (!this.img?.categories || !this.img.categories.length))
        this.getImages();
    },
  },

  methods: {
    isLink(str) {
      const regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      const without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      return regex.test(str) || without_regex.test(str);
    },
    select(image) {
      if (
        !this.computedEditingGallery.images.find((item) => item.id === image.id)
      )
        if (this.onePic) {
          this.$emit("update:field", image.full_path);
          this.computedEditingGallery.images = [];
          this.computedEditingGallery.images[0] = {
            name: image.title,
            title: "",
            url: image.full_path,
            description: "",
            link: "",
            id: image.id,
          };
          this.$forceUpdate();
        } else {
          let arr = this.computedEditingGallery.images;
          this.computedEditingGallery.images = [];
          arr.push({
            name: image.title,
            title: "",
            url: image.full_path,
            description: "",
            link: "",
            id: image.id,
          });
          this.computedEditingGallery.images = arr;
        }
      else {
        this.deleteSelectedImage(this.computedEditingGallery, image);
      }
    },
    async getDefaultImages(search = false) {
      this.defLoading = true;

      if (search) {
        this.showDefResult = true;
        this.defPage = 1;
        this.defIsLastPage = false;
        this.isIntersecting = false;
        this.defImg.items.data = [];
      }

      const res = await rbAxios
        .get(`${this.url}/files/special`, {
          params: {
            bracket: this.bracket ?? undefined,
            paginate: 1,
            page: this.defPage,
            category: this.catSearch,
            search: this.search,
            length: this.per_page,
          },
        })
        .then(({ data }) => {
          let lastImg = search ? [] : this.defImg?.items?.data || [];
          let temp = data.data;
          temp.items.data = lastImg.concat(temp.items.data);
          this.defImg = temp;

          this.defIsLastPage = !data.data.items.next_page_url;
          this.defPage++;
        })
        .catch(({ response }) => {
          this.getDefError = true;
          console.log("error in get default images: ", response);
        })
        .finally(() => (this.defLoading = false));
    },
    async getImages(i) {
      this.loading = true;

      let params = {
        paginate: 1,
        page: this.page,
        category:
          i ?? this.innerTabs > 0
            ? this.img.categories[this.innerTabs - 1]
            : undefined,
        dir: "desc",
      };

      const res = await rbAxios
        .get(`${this.url}/files`, { params })
        .then(({ data }) => {
          let lastImg = this.img?.items?.data || [];
          let temp = data.data;
          temp.items.data = lastImg.concat(temp.items.data);
          this.img = temp;

          if (!!this.defaultCatName) this.categoryName = this.defaultCatName;

          this.isLastPage = !data.data.items.next_page_url;
          this.page++;
        })
        .catch(({ response }) => {
          this.getError = true;
          console.log("error in get images: ", response);
        })
        .finally(() => (this.loading = false));
    },
    moveUp(salon, image) {
      let imageIndex = salon.images.indexOf(image);
      let previousIndex = imageIndex - 1;
      let tempPreviousImage = { ...salon.images[previousIndex] };
      let tempCurrentImage = { ...image };

      salon.images[imageIndex] = tempPreviousImage;
      salon.images[previousIndex] = tempCurrentImage;

      this.$forceUpdate();

      let gallery = this.gallery;
      if (this.value) {
        console.log("here: ", this.value);
        this.$emit("input", [{ name: "", images: [] }]);
        this.$nextTick(() => {
          this.$emit("input", gallery);
        });
      } else {
        this.data["gallery"] = null;
        this.$nextTick(() => {
          this.data["gallery"] = gallery;
        });
      }
    },
    moveDown(salon, image) {
      let imageIndex = salon.images.indexOf(image);
      let nextIndex = imageIndex + 1;
      let tempPreviousImage = { ...salon.images[nextIndex] };
      let tempCurrentImage = { ...image };

      salon.images[imageIndex] = tempPreviousImage;
      salon.images[nextIndex] = tempCurrentImage;

      this.$forceUpdate();

      let gallery = this.gallery;
      if (this.value) {
        this.$emit("input", { name: "", images: [] });
        this.$nextTick(() => {
          this.$emit("input", gallery);
        });
      } else {
        this.data["gallery"] = null;
        this.$nextTick(() => {
          this.data["gallery"] = gallery;
        });
      }
    },
    addGallery() {
      this.gallery.push({
        name: "گالری عکس" + this.gallery.length,
        images: [],
      });
    },
    editGallery(index) {
      this.dialog = true;
      this.editingGallery = index;
    },
    deleteSelectedImage(salon, image) {
      let index = salon?.images?.findIndex((item) =>
        !!item.id ? item.id === image.id : item.url === image.url,
      );
      salon?.images?.splice(index, 1);

      if (this.single && this.onePic && !!this.field)
        this.$emit("update:field", "");
    },
    pushManual() {
      this.manualImage.push({
        title: "",
        url: "",
        description: "",
        link: "",
      });
    },
    addImageManual(salon) {
      if (this.onePic) {
        let v = {
          ...this.manualImage[0],
        };

        salon.images = [];
        salon.images[0] = v;
        this.$emit("update:field", v.url);
      } else {
        this.manualImage
          .filter((item) => !!item.url && this.isLink(item.url))
          .forEach((item) => {
            salon.images.push(item);
          });
      }

      this.manualDialog = false;
      this.dialog = false;

      this.manualImage = [
        {
          name: "",
          title: "",
          url: "",
          description: "",
          link: "",
        },
      ];
    },
    selectImage(image) {
      this.selectedImage = image;
      this.editDialog = true;
    },
    onDefaultIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if (
          (this.isIntersecting || !this.defImg.items.data) &&
          !this.defIsLastPage
        ) {
          this.getDefaultImages();
        }
      });
    },
    onIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if ((this.isIntersecting || !this.img.items.data) && !this.isLastPage)
          this.getImages();
      });
    },
    changeObj() {
      let gallery = this.gallery;
      if (!!this.data) {
        this.data["gallery"] = null;
        this.data["gallery"] = gallery;
      }
      if (!!this.value) this.$emit("input", this.value);
    },
    handleFileUpload(event) {
      let arr = Array.from(event);
      if (!!arr && !!arr.length) {
        // this.errors = arr.filter(e => e.size > 2000000).length > 0 ? 'حداکثر حجم هر تصویر پس زمینه نظر می‌تواند 2 مگابایت باشد.' : ''

        for (const file of arr) {
          if (file.type.match("image.*")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              if (e.total > 2000000) {
                let index = this.filesModel.findIndex(
                  (f) => f.name === file.name,
                );
                this.filesModel.splice(index, 1);
                this.$toast.error(
                  "حداکثر حجم هر تصویر پس زمینه نظر می‌تواند 2 مگابایت باشد.",
                );
                return;
              }

              this.filesPreview.push({
                url: e.target.result,
                name: file.name,
              });
            };
            reader.readAsDataURL(file);
          }
        }
      }
      this.$forceUpdate();
    },
    async uploadFiles(name = this.categoryName) {
      for (const file of this.filesModel) {
        await this.uploadToServer(file, name);
      }
    },
    clearUpload() {
      this.filesModel = null;
      this.filesPreview = [];
      this.categoryName = this.defaultCatName || "";
    },
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;
      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.add("drag-over");
      else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.target.files || e.dataTransfer.files;
        let arr = [];
        for (const file of files) {
          arr.push(file);
        }
        this.filesModel = arr;
        this.handleFileUpload(files);
      } else if (e.type === "click") {
        this.$refs.fileInput.$refs.input.click();
      }
    },
    removeFileFromUpload(index) {
      this.filesModel.splice(index, 1);
      this.filesPreview.splice(index, 1);
    },
    async uploadToServer(file, name) {
      const formData = new FormData();
      this.upLoading = true;

      const index = this.filesModel.indexOf(file);

      let cat = typeof name === "string" ? name : this.categoryName;

      formData.append("file", file);
      formData.append("category", cat);
      formData.append("type", "other");
      formData.append("file_type", "image");

      try {
        this.filesPreview[index].status = "loading";

        await rbAxios
          .post("/files", formData)
          .then((response) => {
            this.filesPreview[index].status = true;
            this.filesPreview[index].color = "success";

            if (
              !!this.filesModel.length &&
              index + 1 >= this.filesModel.length
            ) {
              this.filesModel = null;
              this.filesPreview = [];
              this.$toast.success("با موفقیت آپلود شد.");
              this.gotoSaved(cat);
            }
          })
          .catch((error) => {
            this.filesPreview[index].status = false;
            this.filesPreview[index].color = "error";
            this.$toast.error("خطای آپلود تصویر!");
          });
      } catch (e) {
        console.log(e);
      }

      this.upLoading = false;
    },
    gotoSaved(cat) {
      this.tabs = 3;
      this.page = 1;
      this.img.items = [];

      let it = this.img.categories.findIndex((item) => item === cat) + 1;

      if (it < 0) it = 0;

      this.getImages(it).then(() => {
        this.innerTabs = it;
      });
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .v-tabs >>> .v-slide-group__prev {
    display: none !important;
  }
}

#uploader {
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #797979 !important;
}

.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, 0.33) !important;
}

@media screen and (max-width: 600px) {
  .v-card >>> .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
}
.rowinfo {
  display: flex !important;
  flex-direction: row !important;
  gap: 1px !important;
  justify-content: space-evenly !important;
  margin: 0px !important;
}
.contentinfo {
  flex: 1 1 80% !important;
}
.buttoninfo {
  flex: 1 1 12% !important;
}
</style>
